import { Trans } from '@lingui/react'
import { arrayOf, func, number, shape, string } from 'prop-types'
import { Component } from 'react'

import store, { subscribe } from 'shared/store'
import { HITS_PER_PAGE_FILTER_CHANGED } from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import InputCheckbox from 'views/components/molecules/InputCheckbox'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import ProductFilterModal from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/ProductFilterModal'

import { closeComponentForModal } from './helpers'

import './HitsPerPageMobile.scss'

class HitsPerPageMobile extends Component {
  constructor(props) {
    super(props)

    const { currentRefinement } = props

    this.state = {
      currentRefinement,
    }
  }

  componentDidMount() {
    subscribe.after(HITS_PER_PAGE_FILTER_CHANGED, payload => {
      const { currentRefinement: beforeChangeRefinement } = this.state
      const { currentRefinement } = payload

      if (beforeChangeRefinement !== currentRefinement) {
        this.setState({
          currentRefinement,
        })
      }
    })
  }

  onChange = value => {
    const { refine } = this.props
    const { currentRefinement } = this.state

    if (currentRefinement !== value) {
      store.dispatch({
        type: HITS_PER_PAGE_FILTER_CHANGED,
        refine,
        currentRefinement: value,
      })

      this.setState({
        currentRefinement: value,
      })
    }
  }

  render() {
    const { items, label, id } = this.props
    const { currentRefinement } = this.state
    const modalId = `${id}-modal`

    return (
      <div className="u-no-border-radius u-border--bottom u-padding o-AlgoliaInstantSearch__HitsPerPage__HitsPerPageMobile--wrapper">
        <ModalShowButton
          component={ButtonAsLink}
          name={modalId}
          modalId={modalId}
          className="o-HitsPerPageMobile__modal-button"
          neutral
        >
          <div className="l-flex">
            <p className="u-no-margin u-color--dark l-flex__primary u-text-align--left u-font-weight--bold l-flex l-flex--distribute-space o-HitsPerPageMobile__modal-button-text">
              <span>{label}</span>
              <span className="u-color--greyLight u-font-weight--normal">
                {currentRefinement}
              </span>
            </p>
            <IconCaretRight />
          </div>
        </ModalShowButton>
        <div data-clientside-hook="hitsPerPage">
          <ProductFilterModal
            id={modalId}
            title={label}
            closeComponent={closeComponentForModal()}
          >
            <div className="u-padding--sides">
              <ul className="a-list-reset">
                {items.map(item => {
                  const { value } = item
                  const itemId = `hits-per-page-${value}`

                  return (
                    <li
                      key={itemId}
                      className="u-no-border-radius u-border--bottom@small-tiny u-padding@small-tiny u-margin-x-small--bottom@medium"
                    >
                      <InputCheckbox
                        id={itemId}
                        name={itemId}
                        checked={value === currentRefinement}
                        onChange={() => this.onChange(value)}
                        disableAutoCompleteAndFriends
                        labelSize="small"
                      >
                        {item.label}
                      </InputCheckbox>
                    </li>
                  )
                })}
              </ul>
              <Button
                name={`hits-per-page-close-modal-${id}`}
                className="o-HitsPerPageMobile__cta"
                data-clientside-hook="hitsPerPage__close-modal"
                isClientsideControlled
                ariaHidden="true"
              >
                <Trans id="general.link.label.back" />
              </Button>
              <Button
                name={`hits-per-page-confirm-selection-${id}`}
                className="o-HitsPerPageMobile__cta u-hidden@medium"
                isClientsideControlled
                data-clientside-hook="hitsPerPage__confirm-selection"
                ariaHidden="true"
              >
                <Trans id="general.label.link.apply" />
              </Button>
            </div>
          </ProductFilterModal>
        </div>
      </div>
    )
  }
}

HitsPerPageMobile.propTypes = {
  items: arrayOf(shape({})).isRequired,
  currentRefinement: number.isRequired,
  refine: func.isRequired,
  label: string.isRequired,
  id: string.isRequired,
}

export default HitsPerPageMobile
